// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from './axios'
import './less/index.less'
import './filter'
import VueI18n from 'vue-i18n'
import 'babel-polyfill'
import $ from 'jquery'
import './utils/rem'
import './utils/patch'
import VueClipboard from 'vue-clipboard2'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import footerBar from './components/footer'
import publicHeader from './components/public-header'

// 注册全局组件
import Toast from './components/toast/index'
import Loading from './components/loading/index'

Vue.component('footerBar', footerBar);
Vue.component('publicHeader', publicHeader);

Vue.use(Toast)
Vue.use(Loading)
Vue.use(VueClipboard)
Vue.use(VueI18n)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
})

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$ = $

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh', // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  fallbackLocale: localStorage.getItem('lang') || 'zh',
  messages: {
    'zh': require('@/assets/languages/zh.json'),
    'en': require('@/assets/languages/en.json'),
    'ko': require('@/assets/languages/ko.json')
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js